/* eslint-disable no-shadow */
export enum Breakpoints {
  mobile = 0,
  tablet = 768,
  desktop = 992,
}
/* eslint-enable no-shadow */

export type DeviceScreen = 'mobile' | 'tablet' | 'desktop';
